module.exports = __webpack_public_path__ + "img/recognition-active.f9c5d1d8.svg";